<!-- HERO -->
<header>
  <div class="container">
    <div class="safe-area">
      <div id="logo" class="logo-container">
        <img src="assets/Vittal/img/Group-52.png" alt="Logo" />
      </div>

      <button class="hamburger-menu" aria-label="Menú" (click)="toggleMenu()">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <nav id="navbar" class="navbar-container">
        <a class="nav-link" href="#" (click)="scrollToSection('hero', $event)">Servicio</a>
        <div class="separator" id="separador1"></div>
        <a class="nav-link" href="#" (click)="scrollToSection('testimonios', $event)">Testimonios</a>
        <div class="separator" id="separador2"></div>
        <a class="nav-link" href="#" (click)="scrollToSection('faq', $event)">Preguntas</a>
      </nav>

      <nav class="mobile-menu" [class.active]="isMobileMenuOpen">
        <a class="nav-link" href="#" (click)="scrollToSection('hero', $event)">Servicio</a>
        <a class="nav-link" href="#" (click)="scrollToSection('testimonios', $event)">Testimonios</a>
        <a class="nav-link" href="#" (click)="scrollToSection('faq', $event)">Preguntas</a>
      </nav>

      <div
        class="overlay"
        [class.active]="isMobileMenuOpen"
        (click)="toggleMenu()"
      ></div>

      <div id="social" class="social-icons">
        <a
          href="https://www.instagram.com/tuvidaestaprimero/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="assets/Vittal/img/Group-70.png" alt="Instagram" />
        </a>
        <a
          href="https://www.facebook.com/Tuvidaestaprimero"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="assets/Vittal/img/Group-71.png" alt="Facebook" />
        </a>
        <a
          href="https://www.linkedin.com/company/71491/admin/dashboard/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="assets/Vittal/img/Group-72.png" alt="LinkedIN" />
        </a>
      </div>
    </div>
  </div>
</header>

<section id="hero">
  <img class="green-vector" src="assets/Vittal/img/Vector.png" />
  <img
    class="green-vector-mobile"
    src="assets/Vittal/img/green-vector-mobile.png"
  />

  <div class="hero-container">
    <div class="hero-text">
      <h1>Transformá tu lugar de trabajo en un espacio cardioprotegido</h1>
      <p>
        En una emergencia, cada segundo CUENTA. ¿Estás preparado para salvar
        vidas?
      </p>
    </div>

    <div id="formulario" class="form-container">
      <div class="form-block">
        <h3 class="bajadas">Dejá tus datos y asegurá tu empresa hoy mismo</h3>
        <form [formGroup]="deaForm" (ngSubmit)="onSubmit()">
          <input
            type="text"
            formControlName="nombre"
            placeholder="Nombre y apellido"
            required
          />
          <input type="text" formControlName="empresa" placeholder="Empresa" />
          <input
            type="text"
            formControlName="telefono"
            placeholder="Teléfono"
            required
          />
          <input
            type="email"
            formControlName="email"
            placeholder="Email"
            required
          />
          <input
            type="text"
            formControlName="localidad"
            placeholder="Localidad / Barrio"
          />
          <p class="magnet-text">
            <input type="checkbox" formControlName="magnet" />
            Quiero recibir la Guía Gratuita para RCP y uso de DEA en mi empresa.
          </p>
          <button type="submit" id="btn-form" [disabled]="!deaForm.valid">
            Enviar
          </button>
        </form>
      </div>
    </div>
  </div>
</section>

<section id="beneficios">
  <div class="beneficios-container">
    <p class="bajadas">
      ¿Sabías que una persona asistida con maniobras de RCP + DEA tiene un
      <br />
      <span class="destacadas">75% de posibilidad de sobrevida?</span>
    </p>
    <p class="legales">
      *Según estadísticas del Ministerio de Salud de la Nación
    </p>
  </div>
</section>

<section id="oferta">
  <div class="contenedor-oferta">
    <div class="card-oferta">
      <img id="cardio" src="assets/Vittal/img/cardio.png" />
      <p class="bajadas"><strong>Instalación gratuita</strong></p>
    </div>
    <div class="card-oferta">
      <img id="capacitacion" src="assets/Vittal/img/capacitacion.png" />
      <p class="bajadas"><strong>Capacitación en RCP y DEA</strong></p>
    </div>
    <div class="card-oferta">
      <img id="asistencia" src="assets/Vittal/img/asistencia.png" />
      <p class="bajadas"><strong>Asistencia Inmediata</strong></p>
    </div>
  </div>
  <div class="texto-oferta">
    <p>
      <strong>En vittal ofrecemos una solución integral</strong> que combina
      equipos DEA (Desfibrilador Externo Automático) de última generación con
      capacitación en RCP impartida por profesionales de nuestra fundación.
    </p>
  </div>
</section>

<section id="desfibrilador">
  <div class="desfibrilador-container">
    <div id="dea">
      <h2>Desfibrilador Externo Automático</h2>
      <div class="dea-item">
        <img src="assets/Vittal/img/list.png" id="icono1" class="icon-list" />
        <p id="dea1">Botón único para que su uso sea fácil e intuitivo</p>
      </div>

      <div class="dea-item">
        <img src="assets/Vittal/img/list.png" id="icono2" class="icon-list" />
        <p id="dea2">Instrucciones mediante señales visuales y auditivas</p>
      </div>

      <div class="dea-item">
        <img src="assets/Vittal/img/list.png" id="icono3" class="icon-list" />
        <p id="dea3">Modo adulto y pediátrico</p>
      </div>

      <div class="dea-item">
        <img src="assets/Vittal/img/list.png" id="icono4" class="icon-list" />
        <p id="dea4">
          Evalúa la condición del paciente y aplica automáticamente la descarga
          más adecuada
        </p>
      </div>

      <div class="dea-item">
        <img src="assets/Vittal/img/list.png" id="icono5" class="icon-list" />
        <p id="dea5">Grado de protección IP56</p>
      </div>
    </div>
  </div>
</section>

<section id="testimonios">
  <div class="testimonios-container">
    <div class="title-center">
      <h2 class="destacadas">Ellos confían en nosotros</h2>
      <p>
        Ya son muchas las empresas que eligieron estar preparadas para salvar
        vidas.
        <br />
        Conocé sus historias y cómo transformaron sus espacios en zonas
        cardioprotegidas.
      </p>
    </div>

    <div class="testimonios-items">
      <div class="testimonio">
        <div>
          <h4 class="bajadas"><strong>Cristian Conejeros</strong></h4>
          <p><strong>Danone</strong><br />Gerente de Seguridad y Salud</p>
        </div>

        <p>
          "Nosotros tenemos aproximadamente 50 desfibriladores en cada uno de
          nuestros sitios y plantas. Creemos que es básico y fundamental, tener
          una buena preparación en caso de una emergencia y contar con este tipo
          de equipos; y por supuesto, con el soporte del equipo de vittal."
        </p>
      </div>

      <div class="testimonio">
        <div>
          <h4 class="bajadas"><strong>Victor Guillermo Jefa</strong></h4>
          <p><strong>Danone</strong><br />Referente de brigada de emergencia</p>
        </div>

        <p>
          "Considero que el Desfibrilador Automático Externo es verdaderamente
          importante. Es una herramienta fundamental para nosotros, porque no
          sólo con tus manos podes dar vida, sino que el DEA es un soporte
          esencial. Es importante transmitir y generar conciencia acerca de su
          implementación"
        </p>
      </div>
    </div>
  </div>
</section>

<section id="leadmagnet">
  <div class="leadmagnet-container">
    <div class="col-izq">
      <h2 class="destacadas">
        Descargá gratis nuestra Guía rápida de RCP y uso de DEA
      </h2>
      <p>Aprendé a salvar vidas en tu empresa</p>
      <p>
        Pensada para que vos y tu equipo sepan cómo actuar ante una emergencia.
        Con esta guía vas a aprender: <br />✅ Cómo reconocer un paro
        cardiorrespiratorio <br />✅ Los pasos clave de la RCP <br />✅ Cómo
        usar un DEA de forma segura y efectiva
      </p>
    </div>
    <div class="col-der">
      <p class="bajadas">
        Completá el formulario y accedé<br />ahora mismo a este recurso
        exclusivo.
      </p>
      <button (click)="descargarGuia($event)">
        <a href="#">Quiero mi guía gratuita</a>
      </button>
    </div>
  </div>
</section>

<section id="faq">
  <div class="faq-container">
    <p class="destacadas">Preguntas Frecuentes</p>

    <div class="faq-item" *ngFor="let item of faqItems">
      <button class="faq-btn" (click)="toggleFaq(item)">
        <p class="faq-text">{{ item.pregunta }}</p>
        <img
          src="assets/Vittal/img/flechaabajo.png"
          class="faq-vector"
          [class.active]="item.isOpen"
        />
      </button>
      <div class="faq-answer" [class.active]="item.isOpen">
        <p class="answer-text">{{ item.respuesta }}</p>
      </div>
    </div>
  </div>
</section>

<section id="empresas">
  <div class="empresas-container">
    <h2 class="destacadas">Empresas</h2>
    <p class="">+ de 500 empresas ya cuentan con su espacio cardioprotegido</p>

    <div class="empresas-logos">
      <div class="empresas-logos-slider">
        <ng-container *ngFor="let logo of empresasLogos">
          <img
            [src]="'assets/Vittal/img/' + logo.imagen"
            [alt]="logo.nombre"
            class="empresa-logo"
          />
        </ng-container>
        <ng-container *ngFor="let logo of empresasLogos">
          <img
            [src]="'assets/Vittal/img/' + logo.imagen"
            [alt]="logo.nombre"
            class="empresa-logo"
          />
        </ng-container>
      </div>
    </div>
  </div>
</section>

<section id="footer">
  <div class="footer-container">
    <div class="footer-izq">
      <p class="bajadas">Comunicate con nosotros</p>
      <div class="footer-item">
        <img src="assets/Vittal/img/whatsapp2.png" class="footer-icon" />
        <a href="https://wa.me/1130324842">Whatsapp +54 9 11-3032-4842</a>
      </div>

      <div class="footer-item">
        <img src="assets/Vittal/img/mail.png" id="mail" class="footer-icon" />
        <a href="mailto:solicituddea@vittal.com.ar"
          >SolicitudDEA@vittal.com.ar</a
        >
      </div>
    </div>

    <div class="footer-der">
      <img src="assets/Vittal/img/loguito.png" class="footer-icon" />
      <p>
        vittal Socorro Médico Privado S.A.<br />
        CUIT 30-61221341-7<br />
        R.N.E.M.P. N° 1305<br />
        <a href="https://www.argentina.gob.ar/sssalud" target="_blank"
          >https://www.argentina.gob.ar/sssalud</a
        ><br />
        <a
          href="https://www.vittal.com.ar/assets/terminos-y-condiciones.pdf"
          target="_blank"
          >TÉRMINOS Y CONDICIONES</a
        >
      </p>
    </div>
  </div>
</section>

<div id="whatsapp">
  <a
    href="https://wa.me/1130324842?text=¡Hola! Me interesa recibir más información para contratar el servicio de DEA de vittal para mi empresa."
  >
    <img src="assets/Vittal/img/whatsapp1.png" alt="WhatsApp" />
  </a>
</div>
